import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedMediaIndex } from '../../redux/ai-studio/aiStudioReducer';
import { changeStudioBucket } from '../../redux/ai-studio/aiStudioActions';
import { changeActiv8Tab } from '../../redux/activ8/activ8Reducer';
import { ACTIV8_TABS } from '../../constants';
import { clampMediaIndex } from '../utils/mediaIndex';

const useOpenStudioController = () => {
  const dispatch = useDispatch();
  const [confirmData, setConfirmData] = useState(null);
  const responses = useSelector((state) => state.aiStudio.responses);
  const bucket = useSelector((state) => state.aiStudio.bucket);

  const handleOpenConfirmModal = (data) => {
    setConfirmData(data);
  };

  const handleCloseConfirmModal = () => {
    setConfirmData(null);
  };

  const handleConfirmOpenStudio = () => {
    handleOpenStudio(confirmData);
    handleCloseConfirmModal();
  };

  const handleTryToOpenStudio = ({ media, slideIndex, bucketId }) => {
    if (!responses.length || bucket.bucketId === bucketId) {
      return handleOpenStudio({ media, slideIndex, bucketId });
    }

    handleOpenConfirmModal({ media, slideIndex, bucketId });
  };

  const handleOpenStudio = async ({ media, slideIndex, bucketId }) => {
    if (bucket?.bucketId !== bucketId) {
      await dispatch(changeStudioBucket({ bucketId, media }));
    }
    dispatch(setSelectedMediaIndex(clampMediaIndex(slideIndex, media?.length ?? 0)));
    dispatch(changeActiv8Tab(ACTIV8_TABS.STUDIO));
  };

  return {
    confirmData,
    onOpenConfirmModal: handleOpenConfirmModal,
    onCloseConfirmModal: handleCloseConfirmModal,
    onConfirmOpenStudio: handleConfirmOpenStudio,
    onTryToOpenStudio: handleTryToOpenStudio,
  };
};

export default useOpenStudioController;
